'use strict';

/* global jQuery, PhotoSwipe, PhotoSwipeUI_Default, console */
if ($(window).width() > 769) {
  (function($) {
  
    // Init empty gallery array
    var container = [];
  
    // Loop over gallery items and push it to the array
    $('#gallery-fa').find('figure').each(function() {
      var $link = $(this).find('a'),
        item = {
          src: $link.attr('href'),
          w: $link.data('width'),
          h: $link.data('height'),
          title: $link.data('caption')
        };
      container.push(item);
    });
  
    // Define click event on gallery item
    $('#gallery-fa a').click(function(event) {
  
      // Prevent location change
      event.preventDefault();
  
      // Define object and gallery options
      var $pswp = $('.pswp')[0],
        options = {
          index: $(this).parent('figure').index(),
          bgOpacity: 0.85,
          showHideOpacity: true
        };
  
      // Initialize PhotoSwipe
      var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
      gallery.init();
    });
  
  }(jQuery));
}
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$(document).ready(function(){
  $(".product-slider-zoom-inner").click(function(){
    setTimeout(function(){
      $(".fancybox-stage .slide").click(function(){
        $(this).toggleClass('active')
      });      
    }, 1000);

  });
});

// $(document).ready(function(){
//   setTimeout(function(){
//     $('body .klaviyo-form-WAdq6J button').click(function(){
//     	$('.Footer__Block--newsletter h2').hide();
//       	$('.Footer__Block--newsletter .Footer__Content.Rte').hide();
//     });
//     console.log('timeout');
//   }, 6000); 
// });

// $(function () {
//   var rows = $('.Header__MainNav ul li');

//     var maxHeight = 0;

//     var cols = rows.children('.MegaMenu');
//     for (var i2 = 0; i2 < cols.length; i2++) {
//       var colHeight = $(cols[i2]).innerHeight(); 
//       if (colHeight > maxHeight) {
//         maxHeight = colHeight;
//       }
//     }
// 	$('.Header__MainNav ul li .MegaMenu').css('min-height', maxHeight);
// });

$(document).ready(function(){

  $(".thumbslider .thumb").click(function(){
    $(".thumbslider .thumb").removeClass('active');
    $(this).addClass('active');
  });
  setTimeout(function(){
    $('.plus-but').click(function(){
      $('.slick-active a').click();
      console.log('123')
    });
  }, 1000);
});

if ($(window).width() < 670) {
$(document).ready(function(){
  setTimeout(function(){
    $('.plus-but').click(function(){
      $('.slick-active a').click();
       $(".cs-part").addClass("hide");
      $("#shopify-section-related-products").addClass("hide");
      $("#shopify-section-recently-viewed-products").addClass("hide");
      $("#shopify-section-footer").addClass("hide");
    });
  }, 1000);
});
   $('.mobile-zoom').click(function(){

       $(".cs-part").removeClass("hide");
      $("#shopify-section-related-products").removeClass("hide");
      $("#shopify-section-recently-viewed-products").removeClass("hide");
      $("#shopify-section-footer").removeClass("hide");
    });
}
$(function () {
  var rows = $('.template-product #shopify-section-related-products .ProductList--carousel .Carousel__Cell');

    var maxHeight = 0;

    var cols = rows;
    for (var i2 = 0; i2 < cols.length; i2++) {
      var colHeight = $(cols[i2]).innerHeight(); 
      if (colHeight > maxHeight) {
        maxHeight = colHeight;
      }
    }
	$('.template-product #shopify-section-related-products .ProductList--carousel .Carousel__Cell').css('min-height', maxHeight + 1);
});

$(window).resize(function(){
  var rows = $('.template-product #shopify-section-related-products .ProductList--carousel .Carousel__Cell');

    var maxHeight = 0;

    var cols = rows;
    for (var i2 = 0; i2 < cols.length; i2++) {
      var colHeight = $(cols[i2]).innerHeight(); 
      if (colHeight > maxHeight) {
        maxHeight = colHeight;
      }
    }
	$('.template-product #shopify-section-related-products .ProductList--carousel .Carousel__Cell').css('min-height', maxHeight);
});

var quantityInput = document.querySelector('.QuantitySelector__CurrentQuantity');

if (quantityInput) {
  quantityInput.removeAttribute('autofocus');
}

function setDataCountAbout(cls) {
  $(cls +" .shg-sld-left").hide();   
  cls ? $(cls+" .shg-sld-content").attr('data-count', 2) : $(cls+" .shg-sld-content").attr('data-count', 2)
}

function renderHtmlAbout(cls) {
  let stringSlides = '';
  let text = '';
  $(cls +" .shg-c-lg-4").each(function(index) {
    $(this).addClass('child_' + (index + 1));
    $(this).html() == '' ? $(this).remove() : $(this).addClass('avir')
  });
  $(cls +" .shg-row").each(function(index) {
    stringSlides += $(this).html();
  });  
  $(cls +" .shg-sld-slides").html('<div class="re-render shg-sld-item animate__animated shg-sld-active"><div class="shg-c "><div class="shg-row" data-col-grid-mode-on=""> '+stringSlides+'</div></div></div>');
}

function sldLeftAbout(cls) {
  $(cls +" .shg-sld-left").click(function(){
    let _this = $(this);
    let lengthElementLeft = parseInt(_this.parent().find('.shg-c-lg-4').length);
    let countData = parseInt(_this.parent().attr('data-count'));
    let current = parseInt(countData) - 1
    let prev = parseInt(current) - 1;
    let next = parseInt(current) + 1;   
    if (current < lengthElementLeft) {
      $(cls +" .shg-sld-right").show();   
    }
    if (current == 2) {
      $(cls +" .shg-sld-left").hide();   
    }    
    console.log('current Left', current)
    countData > 1 ? _this.parent().attr('data-count', current ) : _this.parent().attr('data-count', lengthElementLeft );
    _this.parent().find('.shg-c-lg-4').hide();
    _this.parent().find('.child_'+prev).show();
    _this.parent().find('.child_'+current).show();
    _this.parent().find('.child_'+next).show();    
  });  
  
}

function sldRightAbout(cls) {
  $(cls +" .shg-sld-right").click(function(){
    let _this = $(this);
    let lengthElementRight = parseInt(_this.parent().find('.shg-c-lg-4').length);
    let countData = parseInt(_this.parent().attr('data-count'));
    let current = parseInt(countData) + 1
    let prev = parseInt(current) - 1;
    let next = parseInt(current) + 1;   
    $(cls +" .shg-sld-left").show();   
    if (current == lengthElementRight - 1) {
      $(cls +" .shg-sld-right").hide();   
    }        
    countData < lengthElementRight  ? _this.parent().attr('data-count', current ) : _this.parent().attr('data-count', 1 );
    _this.parent().find('.shg-c-lg-4').hide();
    _this.parent().find('.child_'+prev).show();
    _this.parent().find('.child_'+current).show();
    _this.parent().find('.child_'+next).show();

  });  
}

function reRender(){
  setTimeout(function(){
    if ($(".page-about .shg-sld-nav-button")) {
      $(".page-about .shg-sld-nav-button").html('<img src="https://cdn.shopify.com/s/files/1/0093/3262/1427/files/arrow-right.png?v=1703125296" style=" width: 20px; height: 20px; ">');
      $(".page-about .shg-sld-nav-button").addClass('active')
    }
    setDataCountAbout('.page-about #slider-s-3b8a1974-4c05-4485-95d9-d9a9388fd2ec');
    renderHtmlAbout('.page-about #s-3b8a1974-4c05-4485-95d9-d9a9388fd2ec .shg-sld-content');
    sldLeftAbout('.page-about #s-3b8a1974-4c05-4485-95d9-d9a9388fd2ec');
    sldRightAbout('.page-about #s-3b8a1974-4c05-4485-95d9-d9a9388fd2ec');      
  }, 300)  
}
function reRenderSmall(){
  setTimeout(function(){
    if ($(".page-about .shg-sld-nav-button")) {
      $(".page-about .shg-sld-nav-button").html('<img src="https://cdn.shopify.com/s/files/1/0093/3262/1427/files/arrow-right.png?v=1703125296" style=" width: 20px; height: 20px; ">');
      $(".page-about .shg-sld-nav-button").addClass('active')
    }
    setDataCountAbout('.page-about #slider-s-ac040637-38a6-4ba0-97a6-570e8dad3ed5');
    renderHtmlAbout('.page-about #s-ac040637-38a6-4ba0-97a6-570e8dad3ed5 .shg-sld-content');
    sldLeftAbout('.page-about #s-ac040637-38a6-4ba0-97a6-570e8dad3ed5');
    sldRightAbout('.page-about #s-ac040637-38a6-4ba0-97a6-570e8dad3ed5');      
  }, 300)  
}
$(document).ready(function(){
  
  reRender();
  reRenderSmall()
  
  
});